import { computed } from 'mobx';
import { observer } from 'mobx-react';
import { autoinject, bind, ContractInfo, inject, ServicesAlert, StatusCard, Tooltip } from 'Mri.Web.Common';
import * as React from 'react';
import { ContractsStore } from '../../../Contracts/ContractsStore';
import { DisplayGroupItem } from '../../../DisplayGroups/DisplayGroupItem';
import { ActiveDisplay } from '../../ActiveDisplay';

export interface IDisplayGroupsCardProps {
    readonly loading?: boolean;
    readonly display: ActiveDisplay;
}

@autoinject
@observer
export class DisplayGroupsCard extends React.Component<IDisplayGroupsCardProps> {
    public render() {
        return (
            <StatusCard title="Display Groups" loading={this.props.loading}>
                <div className="scroll-container">
                    <div className="scroll-card mt-1">
                        {this.props.display.displayGroups.map((g, k) => (
                            <div className="mb-2 border-bottom-white" key={k}>
                                <DisplayGroupItem displayGroup={g} hideBorder />
                            </div>
                        ))}
                    </div>
                </div>
            </StatusCard>
        );
    }
}
